import script from "./ToggleThemeButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./ToggleThemeButton.vue?vue&type=script&setup=true&lang=ts"

import "./ToggleThemeButton.vue?vue&type=style&index=0&id=c9260846&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c9260846"]])

export default __exports__